import Campaign from "../components/Dashboard/Campaign/Campaign";
import Campaigns from "../components/Dashboard/Campaign/Campaigns";
import CampaignDetails from "../components/Dashboard/Campaign/CampaignDetails";
import GroupCampaign from "@/components/Dashboard/Campaign/GroupCampaign.vue";
import GroupCampaignDetails from "@/components/Dashboard/Campaign/GroupCampaignDetails.vue";
import SubCampaign from "@/components/Dashboard/Campaign/SubCampaign.vue";
import MerchantCampaign from "@/components/Dashboard/Campaign/MerchantCampaign.vue";
import MerchantCampaigns from "@/components/Dashboard/Campaign/MerchantCampaigns.vue";
import MerchantCampaignDetails from  "@/components/Dashboard/Campaign/MerchantCampaignDetails.vue";
const campaignsRoutes = [
  {
    path: "campaign",
    component: Campaign,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "Campaign",
  },
  {
    path: "groupCampaign",
    component: GroupCampaign,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "GroupCampaign",

  },
  {
    path: "groupCampaign/:id/subCampaign",
    component: SubCampaign,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "SubCampaign",
  },
  {
    path: "campaigns",
    component: Campaigns,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "Campaigns",
  },
  {
    path: "campaign/:id",
    component: CampaignDetails,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "CampaignDetails",
  },
  {
    path: "groupCampaign/:id",
    component: GroupCampaignDetails,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "GroupCampaignDetails",
  },
  {
    path: "merchant-campaign",
    component: MerchantCampaign,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "MerchantApp Campaign",
  },
  {
    path: "merchant-campaigns",
    component: MerchantCampaigns,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "MerchantApp Campaigns",
  },
  {
    path: "merchant-campaign/:id",
    component: MerchantCampaignDetails,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "MerchantCampaignDetails",
  },
]

export default campaignsRoutes;